import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "./ui/card";
import {
  Printer,
  Sun,
  Share2,
  Cloud,
  ExternalLink,
  Search,
  Weight,
  Package,
  Eye,
} from "lucide-react";

import featureGraphic from "../assets/kilnhelper_feature_graphic.png";
import appStoreBadge from "../assets/app_store_download.svg";
import googlePlayBadge from "../assets/google-play-badge-cropped.png";
import screenshotProjectShow from "../assets/screenshot_project_show.png";
import screenshotFiringShow from "../assets/screenshot_firing_show.png";
import screenshotMaterialList from "../assets/screenshot_material_list.png";
import bullseyeImg from "../assets/bullseye.jpg";
import spectrumImg from "../assets/spectrum.jpg";

const AboutPage = () => (
  <>
    <div className="flex justify-center">
      <img src={featureGraphic} alt="KilnHelper" />
    </div>
    <h1 className="text-center">An app for Fused Glass Artists.</h1>
    <div className="flex justify-center">
      <a href="https://apps.apple.com/gb/app/kiln-helper/id1506041444">
        <img src={appStoreBadge} alt="Download on the App Store" className="h-[50px]" />
      </a>
      <a href="https://play.google.com/store/apps/details?id=uk.co.muttleycru.kilnhelper">
        <img src={googlePlayBadge} alt="Get it on Google Play" className="h-[50px] ml-2.5" />
      </a>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-items-center pt-5">
      <Card>
        <CardContent>
          <img src={screenshotProjectShow} alt="" className="w-full" />
        </CardContent>
        <CardHeader>
          <CardTitle>Projects</CardTitle>
        </CardHeader>
        <CardDescription className="px-6 pb-6">Keep track of projects</CardDescription>
      </Card>
      <Card>
        <CardContent>
          <img src={screenshotFiringShow} alt="" className="w-full" />
        </CardContent>
        <CardHeader>
          <CardTitle>Firings</CardTitle>
        </CardHeader>
        <CardDescription className="px-6 pb-6">
          Record Firings, and see firing graphs
        </CardDescription>
      </Card>
      <Card>
        <CardContent>
          <img src={screenshotMaterialList} alt="" className="w-full" />
        </CardContent>
        <CardHeader>
          <CardTitle>Materials</CardTitle>
        </CardHeader>
        <CardDescription className="px-6 pb-6">
          Record used Materials and check for Reactions
        </CardDescription>
      </Card>
    </div>
    <div className="max-w-4xl mx-auto px-4">
      <h1 className="text-center text-2xl font-bold my-6">Features</h1>
      <div className="grid grid-cols-2 gap-8">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img className="h-7 w-7 rounded-full" src={bullseyeImg} alt="" />
            <span>Bullseye Glass Database with Reactions</span>
          </div>
          <div className="flex items-center gap-3">
            <img className="h-7 w-7 rounded-full" src={spectrumImg} alt="" />
            <span>Spectrum/Oceanside Glass Database with Reactions</span>
          </div>
          <div className="flex items-center gap-3">
            <Printer className="h-5 w-5 shrink-0" />
            <span>Print Projects</span>
          </div>
          <div className="flex items-center gap-3">
            <Sun className="h-5 w-5 shrink-0" />
            <span>Light or Dark Mode</span>
          </div>
          <div className="flex items-center gap-3">
            <Share2 className="h-5 w-5 shrink-0" />
            <span>Share your Projects with Others</span>
          </div>
          <div className="flex items-center gap-3">
            <Cloud className="h-5 w-5 shrink-0" />
            <span>Cloud Back-End - access your projects from anywhere</span>
          </div>
        </div>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <ExternalLink className="h-5 w-5 shrink-0" />
            <span>Export Firings for Import to Nabertherm Kilns</span>
          </div>
          <div className="flex items-center gap-3">
            <Search className="h-5 w-5 shrink-0" />
            <span>Live Monitoring of supported smart Kiln Controllers</span>
          </div>
          <div className="flex items-center gap-3">
            <Weight className="h-5 w-5 shrink-0" />
            <span>Glass Weight Calculator for Scrap or Mesh Melts</span>
          </div>
          <div className="flex items-center gap-3">
            <Package className="h-5 w-5 shrink-0" />
            <span>Keep an Inventory of all your Materials (Premium Feature)</span>
          </div>
          <div className="flex items-center gap-3">
            <Eye className="h-5 w-5 shrink-0" />
            <span>Interactive Colour Wheel for Bullseye Glass (Premium Feature)</span>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default AboutPage;
